import {
    Box,
    Grid,
    Typography
} from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import YearPicker from 'src/components/YearPicker';
import Page from '../../components/Page';
import PageHeader from '../../components/page-header';
import StatManager from './StatManager';
import StatSection from './StatSection';
import StatType from './StatType';

const StatList = () => {
    const [year, setYear] = useState(moment()); // 현재 연도로 초기화

    return (
        <Page title="Search Engine">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                        <Typography variant='h5' color='#666CFF'>
                            월별 종합 매출통계
                        </Typography>
                    }
                />
            </Grid>
            
            <Box sx={{ mt: 4 }}>
                <YearPicker value={year} onChange={(newYear) => {
                    setYear(newYear);
                }} />
            </Box>
            
            <Grid item xs={12} sm={6} sx={{ mt: 3 }}>
                <StatManager year={year.year()} />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ mt: 3 }}>
                <StatSection year={year.year()} />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ mt: 3 }}>
                <StatType year={year.year()} />
            </Grid>
        </Page>
    );
}

export default StatList;